import React from "react"

import { useHistory } from "react-router-dom"

import { path } from "~Tutor/TutorRoutes"
import { StyledLink } from "~tailwindui/Basics"
import Table from "~tailwindui/Table/Table"

import titlecase from "src/titlecase"

import LocalTime from "components/LocalTime"

type Availability = {
  id: string
  startsAt: string
  endsAt: string
  weekday: string
}

type Subject = {
  id: string
  name: string
}

type Student = {
  id: string
  fullName: string
}

type StudyGroup = {
  id: string
  name: string
  subjects: Subject[]
  students: Student[]
  allAvailabilities: Availability[]
}

export type StudyGroupsProps = {
  studyGroups: StudyGroup[]
  title: string
  changePage?: (page: number) => void
}

const StudyGroups: React.FC<StudyGroupsProps> = ({
  studyGroups,
  title,
  changePage,
}) => {
  const history = useHistory()
  if (studyGroups.length === 0)
    return <span className="italic">No groups to display</span>

  return (
    <Table
      data={studyGroups}
      title={title}
      changePage={changePage}
      rowCallback={({ id }) => history.push(path("studyGroupDetails", { id }))}
      cols={[
        { header: "Study Group Name", value: studyGroup => studyGroup.name },
        {
          header: "Students",
          value: studyGroup => (
            <ul key={studyGroup.id}>
              {studyGroup.students.map(student => (
                <li key={student.id}>
                  <StyledLink
                    to={path("studentDetails", {
                      id: student.id,
                    })}
                  >
                    {student.fullName}
                  </StyledLink>
                </li>
              ))}
            </ul>
          ),
        },
        {
          header: "Subject",
          value: studyGroup =>
            studyGroup.subjects.map(subject => subject.name).join(", "),
        },
        {
          header: "Meeting Times",
          value: studyGroup => (
            <ul key={studyGroup.id}>
              {studyGroup.allAvailabilities.map(availability => (
                <li key={availability.id}>
                  {titlecase(availability.weekday)}{" "}
                  <LocalTime omitDate timestamp={availability.startsAt} /> -{" "}
                  <LocalTime omitDate timestamp={availability.endsAt} />
                </li>
              ))}
            </ul>
          ),
        },
      ]}
    />
  )
}

export default StudyGroups
